import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { Fold } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { _ContestImages, _ContestLink, _ContestCriteria, _QuizTitle, } from "./optics";
import * as Optics from "@discovery/sonic-api-ng-optics";
const ContestlistingView = React.lazy(() => import("./view"));
const getProps = (data) => {
    const imageArray = Fold.toArray(_ContestImages, data);
    const templateIdM = Fold.preview(Optics._Col2TemplateId, data);
    const templateId = M.fromMaybe(templateIdM, "");
    const titleM = Fold.preview(Fold.compose(Optics._ColAttributes2Title, M._Just()), data);
    const title = M.fromMaybe(titleM, "");
    const contestList = [];
    const list = [];
    const quizContestList = [];
    const dataManipulation = () => {
        const linkList = Fold.toArray(_ContestLink, data);
        const quizTitle = Fold.toArray(_QuizTitle, data);
        linkList.map((item, parentindex) => {
            const tempArr = Object.assign({}, item);
            return imageArray.map((child, childIndex) => {
                if (parentindex === childIndex) {
                    tempArr.image = child;
                    return list.push(tempArr);
                }
                else {
                    return;
                }
            });
        });
        list.map((item, parentindex) => {
            const tempArr = Object.assign({}, item);
            return quizTitle.map((child, childIndex) => {
                if (parentindex === childIndex) {
                    tempArr.title = child;
                    return contestList.push(tempArr);
                }
                else {
                    return;
                }
            });
        });
        const contestCriteriaList = Fold.toArray(_ContestCriteria, data);
        contestList.map((item, parentindex) => {
            const newList = Object.assign({}, item);
            return contestCriteriaList.map((child, childIndex) => {
                if (parentindex === childIndex) {
                    const skipContactDetail = M.fromMaybe(child.skipContactDetail, false);
                    newList.activeContestId = child.contestActiveId;
                    newList.skipContactDetail = skipContactDetail;
                    newList.templateId = child.templateId;
                    newList.name = child.name;
                    return quizContestList.push(newList);
                }
                else {
                    return;
                }
            });
        });
    };
    dataManipulation();
    return {
        contestList,
        templateId,
        title,
        quizContestList,
    };
};
const ContestListing = ({ contestList, templateId, title, quizContestList, environment, }) => {
    return (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement(ContestlistingView, { contestList: contestList, templateId: templateId, title: title, quizContestList: quizContestList, read: environment })));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, ContestListing);

